module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results-page"
  }, [_c('div', {
    staticClass: "search-results-container"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("\n      Search results for \""), _c('i', [_vm._v(_vm._s(this.$route.query.search))]), _vm._v("\"\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-filter"
  }, [_c('v-select', {
    attrs: {
      "placeholder": "Filter by Type",
      "value.sync": "selectedType",
      "on-change": _vm.selectType,
      "options": _vm.getContentTypeForSelect
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-result"
  }, [_c('ul', {
    staticClass: "search-result-main"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "search-result-main-item",
      class: _vm.itemClass(item.content_type.type)
    }, [_c('router-link', {
      staticClass: "search-result-main-item-href",
      attrs: {
        "to": {
          name: 'content',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])], 1)
  }), 0)]), _vm._v(" "), (this.noMore === false) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(0), _vm._v("Load more\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-283d697d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/SearchResults.vue
// module id = 958
// module chunks = 0